export default __webpack_public_path__ + "static/media/ke.e2c07d15.jpg";